class TCFHandler {
    constructor() {
        this.permissions_ = {};
        // Mock global __tcfapi to always return undefined
        this.tcfapi = function (command, version, callback) {
            if (typeof callback === 'function') {
                callback(undefined);
            }
        };
    }
    /**
     * Sets the initial listener
     */
    init() {
        if (typeof window.__tcfapi === 'function') {
            this.tcfapi = window.__tcfapi;
        }
    }
    /**
     * Wrapper to TCF API's addEventListener (asynchronous)
     */
    addEventListener(callback) {
        this.tcfapi('addEventListener', 2, response => {
            if (typeof callback === 'function') {
                callback(response);
            }
        });
    }
    /**
     * Gets a single permission
     */
    getPermission(permission) {
        if (this.permissions_[permission] !== undefined) {
            return this.permissions_[permission];
        }
        // If permission is undefined, it might be the first time it's requested,
        // or it might be that the user hasn't granted that particular permission.
        this.tcfapi('getPermission', 2, response => {
            this.permissions_[permission] = response;
        }, permission);
        return this.permissions_[permission];
    }
    /**
     * Wrapper to TCF API's getTCString
     *
     * @param {function} callback
     */
    getTCString(callback) {
        this.tcfapi('getTCString', 2, response => {
            if (typeof callback === 'function') {
                callback(response);
            }
        });
    }
    /**
     * Wrapper to TCF API's getTCData
     *
     * @param {function} callback
     */
    getTCData(callback) {
        this.tcfapi('getTCData', 2, (tcData, success) => {
            if (typeof callback === 'function') {
                callback(tcData, success);
            }
        });
    }
}
export default (new TCFHandler());
